module.exports = __webpack_public_path__ + "img/smoke7.35a9e69d.png";